import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import {
    closeSlidingLayer,
    closeMainAreaLayer,
    selectMainAreaLayers,
    selectSlidingLayers,
} from 'modules/shared/stores/sliding-layers-slice-handler';
import { MemoizedLazyComponent } from 'utils/functions';

function SlidingLayersRenderer() {
    const animationDuration = 300;
    const slidingLayers = useSelector(selectSlidingLayers);
    const slidingLayersRefs = useRef([]);
    const mainAreaLayers = useSelector(selectMainAreaLayers);
    const mainAreaLayersRefs = useRef([]);

    useEffect(() => {
        Object.keys(slidingLayers).forEach((slidingLayerId) => {
            const currentRef = slidingLayersRefs[slidingLayerId];

            if (currentRef.classList.contains('visible')) {
                return;
            }

            slidingLayersRefs.current = currentRef;

            setTimeout(() => {
                currentRef.classList.add('visible');
            });
        });
    });

    useEffect(() => {
        Object.keys(mainAreaLayers).forEach((mainAreaLayerId) => {
            const currentRef = mainAreaLayersRefs[mainAreaLayerId];

            if (currentRef.classList.contains('visible')) {
                return;
            }

            mainAreaLayersRefs.current = currentRef;

            // wait to rerender
            setTimeout(() => {
                currentRef.classList.add('visible');
            });
        });
    });

    const handleClose = (slidingLayerId) => {
        slidingLayersRefs.current.classList.remove('visible');
        setTimeout(() => {
            /**
             * @type {WcfUiSlidingLayerOptions}
             */
            const layerOptions = slidingLayers[slidingLayerId];

            delete slidingLayersRefs[slidingLayerId];
            closeSlidingLayer(slidingLayerId);
        }, animationDuration);
    };

    const handleCloseMainAreaLayer = (mainAreaLayerId) => {
        mainAreaLayersRefs.current.classList.remove('visible');
        delete mainAreaLayersRefs[mainAreaLayerId];
        setTimeout(() => {
            closeMainAreaLayer(mainAreaLayerId);
        }, animationDuration);
    };

    const renderSlider = (sliderId) => {
        /**
         * @type {WcfUiSlidingLayerOptions}
         */
        const slidingLayerOptions = slidingLayers[sliderId];

        return (
            <div
                ref={(ref) => (slidingLayersRefs[sliderId] = ref)}
                className={`wcf-ui-sliding-layer ${slidingLayerOptions.cssClassName || ''}`}
                id={sliderId}
                key={sliderId}
            >
                <div className="top-bar">
                    <div className="close-slide" onClick={() => handleClose(sliderId)}>
                        <span className="icon stw-colapse-general left" />
                    </div>
                    <div className="top-bar-title">
                        <div>{slidingLayerOptions.title ? slidingLayerOptions.title : ''}</div>
                    </div>
                </div>
                <div className="layer-content">{<MemoizedLazyComponent options={slidingLayerOptions} />}</div>
            </div>
        );
    };

    const renderMainAreaLayer = (mainAreaLayerId) => {
        /**
         * @type {WcfUiSlidingLayerOptions}
         */
        const layerOptions = mainAreaLayers[mainAreaLayerId];

        return (
            <div
                ref={(ref) => (mainAreaLayersRefs[mainAreaLayerId] = ref)}
                className={`wcf-ui-main-area-layer ${layerOptions.cssClassName || ''}`}
                id={mainAreaLayerId}
                key={mainAreaLayerId}
            >
                {<MemoizedLazyComponent options={layerOptions} />}
            </div>
        );
    };

    return (
        <>
            {Object.keys(slidingLayers).length > 0 && (
                <div className="wcf-ui-sliding-layers-container">
                    {Object.keys(slidingLayers).map((slidingLayerId) => renderSlider(slidingLayerId))}
                </div>
            )}
            {Object.keys(mainAreaLayers).length > 0 && (
                <div className="wcf-ui-main-area-layers-container">
                    {Object.keys(mainAreaLayers).map((mainLayerId) => renderMainAreaLayer(mainLayerId))}
                </div>
            )}
        </>
    );
}
export default SlidingLayersRenderer;
